import React from 'react'
import Layout from '../../components/layout/Layout'
import DriverTable from '../../elements/tables/driver/DriverTable'

export default function ActiveUsers() {
  return (
    <div>
      <Layout>
        <DriverTable/>
      </Layout>
    </div>
  )
}
